import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, theme } from "shared/lib/styles";

export const Container = styled.div`
  position: relative;

  padding-block: 64px 34px;
  padding-inline: 0;

  background: #f6f6f6;
  ${theme.breakpoints.up("tablet")} {
    padding-block: 64px 58px;
    padding-inline: 0;
  }
`;

export const TextWrapper = styled.div`
  max-inline-size: 335px;
  margin-block: 0;
  margin-inline: auto;
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 638px;
  }
`;

export const Title = styled.div`
  margin-block-end: 8px;

  font-weight: 900;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 24px;
  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 20px;

    font-size: 32px;
    line-height: 38.4px;
  }
`;

export const Points = styled.ul`
  margin-block-end: 23px;

  text-align: center;

  list-style: inside;
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 48px;
    margin-inline-start: 0;
  }
`;

export const Point = styled.li`
  color: #001246;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const Image = styled.img`
  position: relative;
  z-index: 1;

  display: block;

  inline-size: 136px;
  margin-block: 0;
  margin-inline: auto;

  filter: drop-shadow(0 6px 8px rgba(0, 0, 0, 0.25));
  ${theme.breakpoints.up("tablet")} {
    inline-size: 171px;
  }
  ${theme.breakpoints.up("desktop")} {
    inline-size: 214px;
  }
`;

export const SlideContainer = styled.div`
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 0;

  inline-size: 100%;

  transform: translateY(-50%);

  overflow: hidden;
`;

type SlideProps = {
  $bgImage?: StaticImageData;
};

export const Slide = styled.div<SlideProps>`
  block-size: 36px;
  margin-block-end: 17px;

  background-repeat: repeat-x;
  background-size: contain;

  @keyframes slideImage1 {
    100% {
      background-position: 1063px 0;
    }
  }

  @keyframes slideMobileImage1 {
    100% {
      background-position: 1278px 0;
    }
  }

  @keyframes slideImage2 {
    100% {
      background-position: 1031px 0;
    }
  }

  @keyframes slideMobileImage2 {
    100% {
      background-position: 1278px 0;
    }
  }

  @keyframes slideImage3 {
    100% {
      background-position: 1034px 0;
    }
  }

  &:nth-child(1) {
    inline-size: 2116px;

    animation: slideMobileImage1 35s linear infinite;
    ${theme.breakpoints.up("tablet")} {
      inline-size: 3174px;

      animation: slideImage1 22s linear infinite;
    }
  }

  &:nth-child(2) {
    inline-size: 2052px;
    margin-block-end: 0;

    animation: slideMobileImage2 45s linear infinite reverse;
    animation-direction: reverse;
    ${theme.breakpoints.up("tablet")} {
      inline-size: 3078px;
      margin-block-end: 24px;

      animation: slideImage2 35s linear infinite reverse;
    }
    ${theme.breakpoints.up("desktop")} {
      margin-block-end: 41px;
    }
  }

  &:nth-child(3) {
    display: none;

    inline-size: 3087px;
    margin-block-end: 0;
    ${theme.breakpoints.up("tablet")} {
      display: block;

      animation: slideImage3 30s linear infinite;
    }
  }

  ${props =>
    props.$bgImage
      ? css`
          background-image: url(${props.$bgImage});
        `
      : null};

  ${theme.breakpoints.up("tablet")} {
    block-size: 54px;
    margin-block-end: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    block-size: 58px;
    margin-block-end: 41px;
  }
`;
